module.exports = __webpack_public_path__ + "img/jia_highlight.74af8143.png";